<template>
  <div class="audio-box flex-v">
    <div class="audio-wrap" :class="getOptions.txts && 'bg'">
      <ScrollBar ref="scrollbar" v-if="type==1" class="lyric-box">
        <div class="teach-box">
          <div class="left" :style="{transform: `scale(${getKnowledgeSettings.size || 1})`}">
            <LyricManager ref="lyric" v-if="getOptions.txts" @onScroll="onScrollHandler" @onRowClick="rowClickHandler" @onReady="onReady" :txts="getOptions.txts" :options="getOptions" />
          </div>
          <div class="right">
            <!-- 去掉段落选择 -->
            <!-- <RightNav v-if="paraGroups && paraGroups.length" :selected="selectedItem" @itemClick="rightNavItemClick" title="段落选择" :navList="paraGroups" /> -->
            <RightNav v-if="paraGroups && paraGroups.length" :selected="selectedItem" @itemClick="rightNavItemClick"/>
            <slot>
            </slot>
          </div>
        </div>
      </ScrollBar>
      
      <ScrollBar ref="scrollbar" v-if="type==2" class="lyric-box">
        <div class="guide-box">
          <div class="left">
            <LyricManager ref="guide_lyric" @onScroll="onScrollHandler" v-if="getLeftLyricOptions.txts" :txts="getLeftLyricOptions.txts" :options="getLeftLyricOptions" />
          </div>
          <LyricManager ref="lyric" style="display:none" v-if="getOptions.txts" @onReady="onReady" @onLineUpdate="onLineUpdate" :txts="getOptions.txts" :options="getOptions" />
          <slot>
          </slot>
        </div>
      </ScrollBar>
    </div>
    <PointReading @close="pointReadingClose" :styleType="options.wordPageStyle" @onChange="onChangeHandler" v-model="showPointReading" :row="curRow" />
    <Record :isSingle="true" ref="recordRef" @openReport="$emit('openReport')" @onStart="stopPlay" @onClose="pointReadingClose" v-if="type == 1">
      <div class="flex flex-v rdpWrap">
        <div class="flex-center rdpLine">
          点读进度
          <Progress :percentage="(startIndex + 1)/displayLines.length*100" :show-text="false" :stroke-width="10" color="#57AE59" style="flex: 1;margin: 0 10px;"></Progress>
          <span>{{startIndex + 1}}</span>/{{displayLines.length}}
        </div>
        <PointReading @close="pointReadingClose" :isEmbed="true" :styleType="options.wordPageStyle" @onChange="onChangeHandler" :value="true" :row="curRow" />
      </div>
    </Record>
  </div>
</template>
<script>
import LyricManager from 'business/LyricManager';
import PointReading from 'business/PointReading';
import Record from '../../pages/book/record.vue';
import { mapGetters } from "vuex";
import { Progress  } from "element-ui";
export default {
  components: {
    LyricManager,
    PointReading,
    Record,
    Progress
  },
  props: {
    type: {
      type: String,
      default: "1"
    },
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      partNum: -1,
      curRow: {},
      selectedItem: {
        id: -1
      },
      showPointReading: false,
      paraGroups: [], // 段落
      modeOpts: {
        isAuto: true,
        isPlayed: true
      }
    }
  },
  computed: {
    ...mapGetters(["getCurKnowledge","getKnowledgeSettings","getGlobalAudio","getGlobalAudioRate"]),
    getOptions() {
      return {
        type: this.type,
        ...this.options
      }
    },
    guideLyric() {
      return this.$refs.guide_lyric;
    },
    getLeftLyricOptions() {
      let options = this.getOptions;
      return {
        txts: options.artTxts
      }
    },
  },
  watch: {
    options() {
      this.initState();
      this.$nextTick(() => {
        this.init();
        this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true);
      })
    },
    type(newVal, oldVal) {
      if (newVal != oldVal) {
        this.initState();
        this.$nextTick(() => {
          this.init();
          this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true);
        })
      }
    },
    getCurKnowledge(val,oldVal) {
      // this.options.title判断是不是 文章【定位滚动有效】
      if(this.options.title && val.domId)
        this.scrollPos()
    },
    getKnowledgeSettings(val,oldVal) {
      if(val.size !== oldVal.size)
        this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true);
    },
    getGlobalAudioRate(val) {
      // if(val)this._manage.playbackRate = val;
    }
  },
  created() {
    this.initState();
  },
  mounted() {
    this.init();
  },
  methods: {
    initState() {
      this._isPlaying = false; // 内部,
      this._isPlayingOut = false // 外部
      this.isStop = true; // 是否播放完毕
      this.isPause = false;
      this.delayTime = 0;
      this.partTime = 0;
      this.mode = 'auto';
      this._duration = 0;
      this.startIndex = 0;
      this.oldStartIndex = 0;
      this.displayLines = [];
      this.resetPart();
    },
    getLyric() {
      return this.$refs[`lyric`];
    },
    init() {
      let options = this.options;
      let manage = new Audio();
      manage.onended = () => {
        this.stopCallback();
        options.onEnded && options.onEnded();
      }
      manage.oncanplaythrough = () => {
        let duration = manage.duration;
        this.duration = duration;
        options.onReady && options.onReady(duration);
        if (this.getLyric()) {
          this.getLyric().updateDuration(duration);
        }
      }
      manage.ontimeupdate = () => {
        let currentTime = manage.currentTime;
        let percent = currentTime / manage.duration;
        if (this.isStop) {
          currentTime = 0;
        }
        this.currentTime = currentTime;
        options.onTimeUpdate && options.onTimeUpdate(currentTime);
      }
      manage.onpause = () => {
        this.isPause = true;
        options.onPause && options.onPause();
      }
      manage.onplay = () => {
        this.$store.commit("setGlobalAudio", false);
        this.isPause = false;
        options.onChangeState && options.onChangeState(this._isPlayingOut);
        this.onChangeStateCallback(this._isPlayingOut);
        options.onPlay && options.onPlay();
      }
      this._manage = manage;
      if (options) {
        this.setOptions(options)
      }
      if (!window.audioList) {
        window.audioList = [];
      }
      window.audioList.push(manage)
    },
    reset() {
      this._lastLineNum = -1;
      this.currentTime = 0;
      this.options.onTimeUpdate && this.options.onTimeUpdate(0);
      this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true);
      this.getLyric() && this.getLyric().reset();
    },
    onScrollHandler(scrollTop) {
      if (!this._isPlaySingle) {
        this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(scrollTop)
      }
    },
    pointReadingClose() {
      this.updateReadingStatus(false);
    },
    updateReadingStatus(status) {
      this._isPlaySingle = status;
      let options = this.options;
      if (!status) {
        this.startIndex = this.oldStartIndex;
        clearTimeout(this.playSingleTimer)
        this.stop();
        // if (this.startIndex === this.displayLines.length - 1) {
        //   console.log('进入停止')
        //   this.stop();
        // } else {
        //   if (!this.isStop) {
        //     this.pause(true)
        //   }
        // }
      }
    },
    stopPlay() {
      if (this.curRow.isPlay)this.toggle();
    },
    onChangeHandler(type) {
      if (type == 1) {
        if(!this.modeOpts.isAuto) this.modeOpts.isPlayed = false;
        if (this.curRow.preDisabled) {
          return;
        }
        this.playPrev((line, disabled) => {
          this.curRow = {
            ...this.curRow,
            ...line,
            preDisabled: disabled,
            nextDisabled: false
          }
          this.modeOpts.key === 'ai' && this.$refs.recordRef.openDrawer(line.txt)
        })
      }
      if (type == 2) {
        if(!this.modeOpts.isAuto) this.modeOpts.isPlayed = false;
        if (this.curRow.nextDisabled) {
          return;
        }
        this.playNext((line, disabled) => {
          this.curRow = {
            ...this.curRow,
            ...line,
            nextDisabled: disabled,
            preDisabled: false
          }
          this.modeOpts.key === 'ai' && this.$refs.recordRef.openDrawer(line.txt)
        })
      }
      if (type == 3) {
        this.modeOpts.key === 'ai' && this.$refs.recordRef.globalAudio?.pause();
        if(!this.modeOpts.isPlayed) {
          this.modeOpts.playFunc();
          this.modeOpts.isPlayed = true;
          this.curRow.isPlay = true;
          return 
        }
        if (this.curRow.isPlay) {
          this.toggle();
        } else {
          this.playCur();
        }
      }
    },
    async playSingleRow(index = 0, callback) {
      if (!this.getLyric().isHasTime()) {
        return;
      }
      clearTimeout(this.followTimer);
      clearTimeout(this.playSingleTimer);
      let displayLines = this.displayLines;
      let len = displayLines.length;
      let startMinIndex = 0;
      this._isPlaySingle = true;
      this.startIndex = index;
      if (this.selectedItem && this.selectedItem.id > 0) {
        len = this.selectedItem.endIndex;
        startMinIndex = this.selectedItem.startIndex;
      }
      if (index >= len - 1) {
        callback && callback({
          preDisabled: false,
          nextDisabled: true,
          isPlay: this.modeOpts.isAuto
        })
      } else if (index <= startMinIndex) {
        callback && callback({
          preDisabled: true,
          nextDisabled: false,
          isPlay: this.modeOpts.isAuto
        })
      } else {
        callback && callback({
          preDisabled: false,
          nextDisabled: false,
          isPlay: this.modeOpts.isAuto
        })
      }
      this.playLine(this.startIndex)
    },
    playCur() {
      if (!this.getLyric().isHasTime()) {
        return;
      }
      let index = this.startIndex;
      this.pause(true)
      this.playLine(this.startIndex)
    },
    playNext(callback) {
      let displayLines = this.displayLines;
      let len = displayLines.length;
      let options = this.options;
      let line;
      clearTimeout(this.playSingleTimer);
      if (this.selectedItem && this.selectedItem.id > 0) {
        len = this.selectedItem.endIndex;
      }
      clearTimeout(this.playSingleTimer);
      if (this.startIndex < len - 1) {
        this.startIndex++;
        this.pause(true)
        line = this.playLine(this.startIndex);
        if (this.startIndex >= len - 1) {
          callback && callback(line, true)
        } else {
          callback && callback(line, false)
        }
      }
    },
    playPrev(callback) {
      let displayLines = this.displayLines;
      let len = displayLines.length;
      let options = this.options;
      let line;
      let startMinIndex = 0;
      if (this.selectedItem && this.selectedItem.id > 0) {
        startMinIndex = this.selectedItem.startIndex;
      }
      clearTimeout(this.playSingleTimer);
      if (this.startIndex > startMinIndex) {
        this.startIndex--;
        this.pause(true)
        line = this.playLine(this.startIndex);
        if (this.startIndex <= startMinIndex) {
          callback && callback(line, true)
        } else {
          callback && callback(line, false)
        }
      } else {
        callback && callback(line, true)
      }
    },
    onChangeStateCallback(isPlay) {
      if (this.curRow) {
        this.curRow.isPlay = isPlay;
      }
    },
    onLineUpdate(result) {
      let { txt } = result;
      if (this.guideLyric) {
        this.guideLyric.setActivedByTxt(txt);
      }
      this.options.onLineUpdate && this.options.onLineUpdate(result);
    },
    onReady(result) {
      let { displayLines, paraGroups } = result;
      this.displayLines = displayLines
      this.paraGroups = paraGroups;
      this.options.onLiricReady && this.options.onLiricReady(result);
      this.$nextTick(() => {
        this.reset();
      })
    },
    seekOrLine(s) {
      if (this.mode == 'auto') {
        this.seek(s)
      } else {
        let startIndex = this.getLyric().findCurNum(s);
        clearTimeout(this.playSingleTimer);
        clearTimeout(this.followTimer);
        this.startIndex = startIndex;
        this.playLine(this.startIndex, s);
      }
    },
    setOptions(options) {
      this.getLyric() && this.getLyric().stop();
      if (options.src) {
        this._manage.src = options.src;
        // this._manage.playbackRate = this.getGlobalAudioRate;
      }
      if (options.autoplay) {
        this.play();
      }
    },
    playLine(index, startTime) {
      // ==========crs======倍数=======
      let line = this.getDisplayLineByIndex(index);
      if (line) {
        let s = line.time / 1000;
        clearTimeout(this.playSingleTimer);
        if (startTime) {
          s = startTime;
        }
        let delayTime = line.playTime;
        let followTime = delayTime;
        if (startTime) {
          delayTime = delayTime - (startTime * 1000 - line.time);
          if (delayTime < 0) {
            delayTime = 0;
            this.seekedCallback(10, followTime);
            return;
          }
        }
        console.log(this.modeOpts.isAuto,'seek:' + s + ',延迟:' + delayTime + "," + followTime + "," + line.time)
        if(this.modeOpts.isPlayed) {
          this.seek(s);
          this.seekedCallback(delayTime, followTime);
        } else {
          this.modeOpts.playFunc = () => {
            this.seek(s);
            this.seekedCallback(delayTime, followTime);
          }
        }
      }
      return line;
    },
    seekedCallback(delayTime, followTime) {
      let options = this.options;
      const callNextLine = (max) => {
        if (this.startIndex < max) {
          console.log('调用下一句：' + this._isPlayingOut)
          this.playLine(this.startIndex)
        } else {
          options.onFollowStop && options.onFollowStop();
          this.stop();
          clearTimeout(this.followTimer)
        }
      }
      if (this.getLyric() && delayTime > 0) {
        let d1 = new Date();
        this.playSingleTimer = setTimeout(async () => {
          if (this._isPlayingOut) {
            let isResetState = false;
            if (this._isPlaySingle) {
              isResetState = true;
            } else {
              if (this.mode == 'follow') {
                isResetState = false;
              } else {
                isResetState = true;
              }
            }
            this.pause(isResetState);
          }
          if (this.mode == 'follow') {
            if (!this._isPlaySingle) {
              this.followTimer = setTimeout(() => {
                if (this._isPlayingOut) {
                  this.startIndex++;
                  callNextLine(this.endIndex > 0 ? this.endIndex : this.displayLines.length)
                }
              }, followTime)
            } else {
              this._isPlaying = false;
              this._isPlayingOut = false;
              clearTimeout(this.followTimer)
            }
          } else {
            this._isPlaying = false;
            this._isPlayingOut = false;
          }
          clearTimeout(this.playSingleTimer);
        }, delayTime)
      }
    },
    getDisplayLineByIndex(index) {
      let displayLines = this.displayLines;
      return displayLines[index]
    },
    rowClickHandler({ row, index }) {
      if (this.getLyric().isHasTime()) {
        this.$emit('onRowClick', { row, index })
      }
    },
    clickSingleRow({ row, index }, {isAuto = true,key}) {
      key === 'ai' ? this.$refs.recordRef.openDrawer(row.txt) : this.showPointReading = true;
      this.modeOpts = {
        isAuto,
        key,
        isPlayed: isAuto
      }
      this.playSingleRow(index, (p) => {
        this.curRow = {
          ...this.curRow,
          ...row,
          ...p
        }
      })
    },
    getMode() {
      return this.mode;
    },
    pause(resetState = false) {
      this._isPauseReady = false;
      this._isPlaying = false;
      console.log('pause')
      this._manage && this._manage.pause();
      this.getLyric() && this.getLyric().pause();
      if (resetState) {
        this._isPlayingOut = false;
        clearTimeout(this.followTimer);
        clearTimeout(this.playSingleTimer);
      }
      this.options.onChangeState && this.options.onChangeState(this._isPlayingOut);
      this.onChangeStateCallback(this._isPlayingOut);
    },
    stop() {
      this.modeOpts = {
        isAuto: true,
        isPlayed: true
      }
      this._manage && this._manage.pause();
      this._manage.currentTime = 0;
      this.getLyric() && this.getLyric().stop();
      this.stopCallback();
    },
    seek(s, noPlay) {
      this._manage.currentTime = s;
      this.isStop = false;
      this._isPlayReady = false;
      this._isPlaying = true;
      this._isPlayingOut = true;
      if (!noPlay) {
        this._manage.play();
      }
      this.getLyric() && this.getLyric().seek(s);
    },
    play(isSeek, force) {
      if (!this._isPlaying) {
        let options = this.options;
        this._manage && this._manage.play().then(() => {
          this.isStop = false;
          this._isPlayingOut = true;
          this._isPlaying = true;
        }).catch(err => {
          this._isPlaying = false;
          this._isPlayingOut = false;
        })
        this.getLyric() && this.getLyric().play();
      }
    },
    replay() {
      this._manage.currentTime = 0;
      if (this.mode == 'follow') {
        setTimeout(() => {
          console.log('-------setTimeout-----33')
          this.playLine(this.oldStartIndex, 0)
        }, 10)
      } else {
        this.play();
      }
    },
    resume() {
      clearTimeout(this.partTimeTimer);
      if (this.mode == 'follow') {
        let currentTime = this._manage.currentTime;
        console.log('follow恢复:' + currentTime)
        clearTimeout(this.playSingleTimer);
        clearTimeout(this.followTimer);
        this.playLine(this.startIndex, currentTime);
      } else {
        this._manage && this._manage.play();
        this.getLyric() && this.getLyric().resume();
      }
    },
    async toggle() {
      if (this._isPlayingOut) {
        this._isPlaying = false;
        this._isPlayingOut = false;
        clearTimeout(this.followTimer);
        clearTimeout(this.partTimeTimer);
        this.pause()
      } else {
        if (this.partNum > 0) { // 段落播放模式
          if (this.isStop) {
            this.setPartItem(this.selectedItem);
            if (this.mode == 'auto') {
              if (this.selectedItem.id > 0) {
                this.seek(this.selectedItem.s);
              } else {
                this.play()
              }
            } else {
              this.playLine(this.startIndex, 0)
            }
          } else {
            this.resume();
          }
          if (this.partTime > 0 && this.mode == 'auto') {
            let partTime = this.partTime;
            let selectedItem = this.selectedItem;
            let offset = 0;
            if (selectedItem.s) {
              offset = this.currentTime - selectedItem.s;
              if (offset > 0) {
                partTime = partTime - offset * 1000;
              }
            }
            this.partTimeTimer = setTimeout(() => {
              console.log('-------setTimeout-----44')
              this.stop()
            }, partTime)
          }
        } else {
          if (!this.isStop) {
            this.resume();
          } else {
            if (this.mode == 'auto') {
              this.play()
            } else {
              this.playLine(this.startIndex, 0)
            }
          }
        }
        this._isPlaying = true;
        this._isPlayingOut = true;
      }
    },
    switchMode(mode, noPlay) {
      let options = this.options;
      if (!mode) {
        this.mode = this.mode == 'auto' ? 'follow' : 'auto';
      } else {
        this.mode = mode;
      }
      options.onModeChange && options.onModeChange(this.mode)
      clearTimeout(this.playSingleTimer);
      clearTimeout(this.followTimer);
      if (noPlay) {
        return;
      }
      this.stop();
      this._isPlaying = false;
      this._isPlayingOut = false;
      this.startIndex = this.oldStartIndex;
      if (this.mode == 'follow') {
        this._isPlaySingle = false;
      } else {
        this.followTimer = 0;
        // if (this.selectedItem && this.selectedItem.id > 0) {
        //   this.setPartItem(this.selectedItem, true);
        // } else {
        //   this.replay();
        // }
      }
    },
    stopCallback() {
      let options = this.options;
      this._isPlayingOut = false;
      this.isStop = true;
      this.isPause = false;
      this._isPlaying = false;
      this.startIndex = this.oldStartIndex;
      clearTimeout(this.followTimer);
      clearTimeout(this.partTimeTimer);
      options.onChangeState && options.onChangeState(this._isPlayingOut);
      this.onChangeStateCallback(this._isPlayingOut);
      if (this._isPlaySingle) { // 如果当前是单行播放的状态，不做停止处理
        return
      }
      this.reset();
      if (this.getLyric() && this.getLyric().isHasTime()) {
        this.getLyric().stop();
      }
      if (this.guideLyric) {
        this.guideLyric.stop();
      }
    },
    resetPart() {
      clearTimeout(this.partTimeTimer);
      if (this.getLyric()) {
        let item = {
          id: -1
        }
        this.getLyric().showAsPartNum(item.id);
        this.selectedItem = item;
      }
    },
    setPartItem(item) {
      if (this.mode == 'auto') {
        if (item.s && item.id > 0) {
          this.partTime = item.isLast ? 0 : item.partTime;
        } else {
          this.partTime = 0;
        }
      }
    },
    rightNavItemClick(item) {
      this.stop();
      this.partNum = item.id;
      this.setPartItem(item);
      this.selectedItem = item;
      this.getLyric().showAsPartNum(item.id);
      clearTimeout(this.followTimer);
      if (item.id != -1) {
        this.startIndex = item.startIndex;
        this.oldStartIndex = item.startIndex;
        this.endIndex = item.endIndex;
      } else {
        this.startIndex = 0;
        this.oldStartIndex = 0;
        this.endIndex = -1;
      }
      this.$emit('onPartItemClick', item)
    },
    destroy() {
      this.stop();
    },
    scrollPos() {
      this.$nextTick(() => {
        const parent = document.querySelector('.vue-scrollbar__wrapper');
        const sub = document.querySelector('.' + this.getCurKnowledge.domId)
        const y = parseInt(sub.offsetTop - parent.offsetTop) * (this.getKnowledgeSettings.size || 1);
        this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(y, true);
      })
    }
  },
  beforeDestroy() {
    this.destroy();
  }
}
</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';

.rdpWrap {
  width: 100%;
  height: 100%;
  .rdpLine {
    padding: 20px 32px;
    font-size: 18px;
    color: #666666;
    span {
      color: #57AE59;
      font-size: 24px;
      margin-top: -6px;
    }
  }
}
.audio-box {
  flex: 1;
  overflow: hidden;

  .audio-wrap {
    flex: 1;
    overflow: hidden;
    
    min-width: 1000px;
    width: 66%;
    margin: 0 auto;
    &.bg {
      background: #FFFCF7;
      box-shadow: 0px 0px 10px 1px rgba(189,94,39,0.05), inset 0px 0px 33px 10px rgba(255,255,255,0.5);
      border-radius: 16px 16px 0px 0px;
    }
    
    ::-webkit-scrollbar {
      width: 0;
      height: 0;
      background: transparent;
    }
  }

  .lyric-box {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .teach-box {
    height: 100%;

    .left {
      padding: 0 106px;
      margin-right: 130px;
      height: 100%;
      transform-origin: top center;
      margin: 0 auto;
      /deep/.word-display {
        padding-top: 20px;
      }
    }

    /deep/ .right {
      position: fixed;
      right: 0;
      top: 179px;
      z-index: 2;
    }
  }

  .guide-box {
    display: flex;
    height: 100%;
    padding: 0 100px;
    .left {
      flex: 1;
      min-width: 500px;
      margin-right: 500px;
    }
  }
}
</style>